import { DSButton } from '@engenharia/ds-react';
import { useTranslation } from 'react-i18next';
import { BiRightArrowAlt } from 'react-icons/bi';

import Button from '../atoms/Button';

import { Action, ActionGroup, Container } from './styles';

export default function Footer({
  activeStep,
  listStep,
  onGoNext,
  onGoBack,
  onSkip,
  loading,
  isPartner,
  disabled,
  hasMarginTop = true,
  isLastStep: isLastStepProp,
  maxWidth,
}) {
  const { t } = useTranslation();
  const isLastStep = isLastStepProp ?? activeStep === listStep.length - 1;
  const hasSplitActions = !!onGoBack && !!onSkip;

  const setLabelButton = (step) => {
    if (isLastStep) {
      return t('settings.steps.contact.startTrial');
    }

    const labels = {
      0: 'settings.steps.continue',
      1: 'settings.steps.profiles.button',
      2: 'settings.steps.aboutYou.button',
      3: 'settings.steps.welcome.button',
      default: '',
    };

    if (isPartner) {
      return t(labels[2]);
    }

    return t(labels[step] || labels.default);
  };

  return (
    <Container $hasMarginTop={hasMarginTop}>
      <Action $maxWidth={maxWidth} $splitActions={hasSplitActions}>
        {hasSplitActions ? (
          <>
            <ActionGroup>
              {!!onGoBack && activeStep !== 0 && (
                <DSButton
                  className="stroke"
                  disabled={loading}
                  onClick={onGoBack}
                  variant="outline"
                >
                  {t('button.back')}
                </DSButton>
              )}
            </ActionGroup>
            <ActionGroup>
              {!!onSkip && (
                <DSButton className="outline" disabled={loading} onClick={onSkip} variant="outline">
                  {t('button.skip')}
                </DSButton>
              )}
              {activeStep !== listStep.length && (
                <Button
                  className={isLastStep ? 'green-button' : ''}
                  disabled={disabled || loading}
                  onClick={onGoNext}
                  endIcon={!isLastStep ? <BiRightArrowAlt /> : undefined}
                >
                  {setLabelButton(activeStep)}
                </Button>
              )}
            </ActionGroup>
          </>
        ) : (
          <>
            {!!onGoBack && activeStep !== 0 && (
              <DSButton className="stroke" disabled={loading} onClick={onGoBack} variant="outline">
                {t('button.back')}
              </DSButton>
            )}
            {!!onSkip && (
              <DSButton className="outline" disabled={loading} onClick={onSkip} variant="outline">
                {t('button.skip')}
              </DSButton>
            )}
            {activeStep !== listStep.length && (
              <Button
                className={isLastStep ? 'green-button' : ''}
                disabled={disabled || loading}
                onClick={onGoNext}
                endIcon={!isLastStep ? <BiRightArrowAlt /> : undefined}
              >
                {setLabelButton(activeStep)}
              </Button>
            )}
          </>
        )}
      </Action>
    </Container>
  );
}
